export default Object.freeze({ CHANGE_TAB: "CHANGE_TAB" });
